import * as React from "react";
import { Context } from "./_context";
export const NavigationBackIcon = ({ size = 24, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M10.823 1.055a.25.25 0 0 1 .354 0l1.767 1.768a.25.25 0 0 1 0 .354L5.621 10.5H22.75a.25.25 0 0 1 .25.25v2.5a.25.25 0 0 1-.25.25H5.621l7.323 7.323a.25.25 0 0 1 0 .354l-1.767 1.767a.25.25 0 0 1-.354 0L.94 13.06a1.5 1.5 0 0 1 0-2.12l9.884-9.885Z", fill: "currentColor" }));
  return iconset[size];
};
NavigationBackIcon.iconId = "sEkxC2";
